import { render, staticRenderFns } from "./v-avatar.vue?vue&type=template&id=c9a86d3c&scoped=true&"
import script from "./v-avatar.vue?vue&type=script&lang=ts&"
export * from "./v-avatar.vue?vue&type=script&lang=ts&"
import style0 from "./v-avatar.vue?vue&type=style&index=0&id=c9a86d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a86d3c",
  null
  
)

export default component.exports